// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2S_ge","head":"Table_head__C9VNe","col":"Table_col__24gNV"};